import React from "react";

const ResumeCard = ({ title, subTitle, result, des }) => {
  return (
    <div className="w-full h-1/3 group flex">
      <div className="w-10 h-[6px] bgOpacity mt-16 relative">
        <span className="absolute w-5 h-5 rounded-full -top-2 -left-3 flex justify-center items-center bg-slate-950 border border-white/10">
          <span className="w-3 h-3 rounded-full bg-slate-700 inline-flex group-hover:bg-designColor group-hover:shadow-[0_0_12px_rgba(0,240,255,0.5)] duration-300"></span>
        </span>
      </div>
      <div className="w-full glass-panel rounded-2xl p-4 lgl:px-10 flex flex-col justify-center gap-6 lgl:gap-10">
        <div className="flex flex-col lgl:flex-row justify-between gap-4 lgl:gap-0 lgl:items-center">
          <div>
            <h3 className="text-xl md:text-2xl font-semibold group-hover:text-white duration-300 text-slate-100">
              {title}
            </h3>
            <p className="text-sm mt-2 text-slate-400 group-hover:text-slate-300 duration-300 font-mono">
              {subTitle}
            </p>
          </div>
          <div>
            <p className="px-4 py-2 text-emerald-400 bg-emerald-500/10 border border-emerald-500/20 rounded-full flex justify-center items-center text-sm font-mono font-medium">
              {result}
            </p>
          </div>
        </div>
        <p className="text-sm md:text-base font-medium text-slate-400 group-hover:text-slate-300 duration-300">
          {des}
        </p>
      </div>
    </div>
  );
};

export default ResumeCard;
